// extracted by mini-css-extract-plugin
export default {"mobile":"PatternTabContent_mobile__9uKxJ"};